<template>
    <div>
        <vueHeader :navNum='3'></vueHeader>

        <div class="banner">
            <img src="./../assets/img/horse/banner.jpg" alt="">
        </div>

        <ul class="advantage">
            <li v-for="(item,index) in advantage" :key="index">
                <img :src="item.img" />
                <p class="title">{{item.advantage}}</p>
                <p class="introduce wow fadeIn" data-wow-duration="1s" :data-wow-delay="index%3*0.1+'s'">{{item.introduce}}</p>
            </li>
        </ul>

        <div class="about">
            <div class="left">
                <h3>精彩瞬间纪录片</h3>
                <p>Lotohof Sporthorses Center位于德国萨尔州的萨尔-洪斯吕克自然公园内，面积15万平方米。距离著名的摩泽尔河谷的大弯5分钟车程，行车10分钟可分别到达法国和卢森堡，约30分钟车程可到达卢森堡国际机场，距离法兰克福200km，距离巴黎300km。瑞士、比利时、荷兰、以及英吉利海峡隧道都可以方便驱车抵达。</p>
                <div class="btn" @click="videoBtn()">
                    <span>立即查看</span>
                    <div class="sanjiao"></div>
                </div>
            </div>
            <div class="right">
                <video id="myVideo" src="./../assets/img/video.mp4" loop controls></video>
                <!-- <div class="poster" v-show="!play"></div> -->
                <div class="play" v-show="!play" @click="videoPlay()">
                    <img src="./../assets/img/horse/play.png" />
                </div>
            </div>
        </div>

        <div class="news" v-if="false">
            <div class="title">
                精彩资讯
                <router-link to="/horseList">
                    <div class="more">more</div>
                </router-link>
            </div>
            <swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if="news.length">
                <!-- slides -->
                <swiper-slide v-for="(item,index) in news.slice(0,9)" :key="index">
                    <div class="item" @click="goArtical(item.id)">
                        <div class="news_img">
                            <img :src="item.cover" />
                            <div class="desc">{{item.txt}}</div>
                        </div>
                        <div class="bottom">
                            <p class="headline">{{item.title}}</p>
                            <p class="time">{{item.month}}-{{item.day}}</p>
                            <p class="txt">{{item.desc.substring(0,110)}}...</p>
                        </div>
                    </div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="point" slot="pagination"></div>
            </swiper>
        </div>

        <div class="rotate">
            <div class="border"></div>
            <swiper class="swiper swiper-container-free-mode" :options="swiperRotate" ref="mySwiper">
                <swiper-slide v-for="(item,index) in rotate" :key="index">
                    <img :src="item.img" class="swiperImg" />
                    <div class="point" slot="pagination"></div>
                </swiper-slide>
            </swiper>
            <div class="border"></div>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            play: false,
            advantage: [
                {
                    img: require('./../assets/img/horse/icon1.png'),
                    advantage: '品种优良',
                    introduce: '现有品种优良的种公马多匹，血统纯正基因稳定用于繁育温血马、纯血马、阿拉伯马等纯种马及其它半血良种马。',
                },
                {
                    img: require('./../assets/img/horse/icon2.png'),
                    advantage: '环境优美',
                    introduce: '马场总面积约为15万平方米，环境优美，空气清新。马场拥有数十间专业马房以及其他专业配套设施。',
                },
                {
                    img: require('./../assets/img/horse/icon3.png'),
                    advantage: '专业指导',
                    introduce: '马场拥有一支专业技术队伍，有专业教练、职业骑师、驯马师，亦配有专业的饲养员、兽医师及优秀的管理人员。',
                },
                {
                    img: require('./../assets/img/horse/icon4.png'),
                    advantage: '定制服务',
                    introduce: '马场为广大马术爱好者量身定制提供专业指导和优质的骑术训练课程，课程中根据爱好程度身体情况等，随时调整骑术指导内容。',
                },
                {
                    img: require('./../assets/img/horse/icon5.png'),
                    advantage: '安全合理',
                    introduce: '无论是马匹还是骑手的安全始终是我们最关注的。马场具有良好的技术设计支持和完善的辅助设计工具，来完善设计的合理性。',
                },
                {
                    img: require('./../assets/img/horse/icon6.png'),
                    advantage: '追求卓越',
                    introduce: '我们对马匹的爱护是发自内心的，您的满意也是我们的追求目标。私人订制马术装备，打造专属马场风格，彰显独树一帜品位。',
                },
            ],
            news: [],
            swiperOption: {
                notNextTick: true,
                slidesPerView: 3,
                spaceBetween: 0,
                slidesPerGroup: 3,
                loop: true, //循环
                initialSlide: 0, //设定初始化时slide的索引
                //autoplay: false, //自动播放
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                speed: 1200, //滑动速度
                direction: "horizontal", //滑动方向
                on: {
                },
                pagination: {
                    //分页器设置
                    el: ".point",
                    clickable: true
                }
            },
            rotate: [
                {
                    img: require('./../assets/img/horse/rotate01.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate02.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate03.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate04.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate05.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate06.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate07.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate08.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate09.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate10.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate11.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate12.png'),
                },
                {
                    img: require('./../assets/img/horse/rotate13.png'),
                }
            ],
            swiperRotate: {
                slidesPerView: 'auto',
                spaceBetween: 8,
                freeMode: true,
                loop: true,
                speed: 10000,
                autoplay: {
                    delay: 0,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
            }
        }
    },

    mounted() {
        window.scrollTo(0, 0);

        new WOW().init();

        this.news = this.$store.state.horseArtical;

        let _this = this;
        let myVideo = document.getElementById('myVideo');

        myVideo.addEventListener('play', function () {
            _this.play = true;
            console.log(myVideo.paused);
        });
        myVideo.addEventListener('pause', function () {
            if (myVideo.paused) {
                _this.play = false;
            }
        })
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },

    methods: {
        videoPlay() {
            let _this = this;
            this.play = true;
            let myVideo = document.getElementById('myVideo');

            if (this.play) {
                myVideo.play();
            }
        },
        videoBtn() {
            console.log(this.play)
            let myVideo = document.getElementById('myVideo');
            if (this.play) {
                myVideo.pause();
            } else {
                myVideo.play();
            }
        },
        goArtical(id) {
            this.$store.commit('changehorseArticalId', id);
            this.$router.push({ path: '/horseContent' });
        }
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/horsemanship.less";
.rotate {
    margin-top: 111px;
    .swiper-slide {
        width: 240px;
        height: 140px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/horsemanship.vue